import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=4100f174&scoped=true"
import script from "./ProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=4100f174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4100f174",
  null
  
)

export default component.exports